import { Component, isDevMode } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalstorageService } from 'src/core/data/localstorage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Satcom-Dashboard';
  sampleText = 'This is some Text';

  isShow = true;
  vendorInfo: any;

  constructor(private route: ActivatedRoute, private localStorageService: LocalstorageService) {
    console.log('Is dev mode? ', isDevMode());
    this.vendorInfo = this.route.snapshot.data['vendorInfo'];
    console.log('fetch vendorInfo from app: ', this.vendorInfo );
  }

  setProperties(){
    let properties = this.localStorageService.vendor;  
    console.log('Properties: ', properties);
    document.documentElement.style.setProperty("--main-bg-color", properties.color);
  }

  toggleDisplay() {
    this.isShow = !this.isShow;
  }
}